import { Either } from 'src/utils/either';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from 'src/http';
import { endpoints } from 'src/utils/axios';

export class PromoterTermsRepository {
  constructor(private api: HttpTypes.HttpClient) { }

  async findPromoterTerms(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.personalization.promoterTerms.one,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async sendPromoterTerms(
    body?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.personalization.promoterTerms.new,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

}
